import { Component, OnInit, TemplateRef } from '@angular/core';
import { CategoriaService } from '../../../services/categoria.service';
import { Categoria } from '../../../models/categoria';
import { ProductoService } from '../../../services/producto.service';
import { Producto } from '../../../models/producto';
import { Venta } from '../../../models/venta';
import { VentaDetalle } from '../../../models/venta_detalle';
import { VentaService } from '../../../services/venta.service';
import { ParametroService } from '../../../services/parametro.service';
import { SessionService } from '../../../services/session.service';
import { TipoComprobanteService } from '../../../services/tipo-comprobante.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Cliente } from '../../../models/cliente';
import { ClienteService } from '../../../services/cliente.service';
import { ClienteModalComponent } from '../../modals/cliente-modal/cliente-modal.component';
import { Cobro } from '../../../models/cobro';
import { CobroDetalle } from '../../../models/cobro_detalle';
import { FormaPagoService } from '../../../services/forma-pago.service';
import { Validation } from '../../../config/validation';
import { ConfirmacionAnulacionModalComponent } from '../../../components/modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import * as moment from 'moment';
import * as numeral from 'numeral';
import { AsignacionCajaService } from '../../../services/asignacion-caja.service';
import { AperturaCajaModalComponent } from '../../modals/apertura-caja-modal/apertura-caja-modal.component';
import { CajaService } from '../../../services/caja.service';
import { Caja } from '../../../models/caja';
import { CierreCajaModalComponent } from '../../modals/cierre-caja-modal/cierre-caja-modal.component';
import { SweetMessage } from '../../../config/sweet-message';
import { CbtContadorService } from '../../../services/cbt-contador.service';
import { BodegaService } from '../../../services/bodega.service';
import { Bodega } from '../../../models/bodega';
import { FacturaModalComponent } from '../../modals/factura-modal/factura-modal.component';
import { ReporteModalComponent } from '../../modals/reporte-modal/reporte-modal.component';
import { TipoTarjeta } from '../../../models/tipo-tarjeta';
import { TipoTarjetaService } from '../../../services/tipo-tarjeta.service';
import { ConfigService } from '../../../config/config-service';
import { environment } from '../../../../environments/environment';
import { LectorBarraModalComponent } from '../../modals/lector-barra-modal/lector-barra-modal.component';
import { ImpuestoPorcentajeService } from '../../../services/impuesto-porcentaje.service';

@Component({
  selector: 'app-punto-venta-tactil-add',
  templateUrl: './punto-venta-tactil-add.component.html',
  styleUrls: ['./punto-venta-tactil-add.component.css'],
  providers: [
        CategoriaService,
        ProductoService,
        VentaService,
        ParametroService,
        TipoComprobanteService,
        ClienteService,
        FormaPagoService,
        AsignacionCajaService,
        CajaService,
        BodegaService,
        TipoTarjetaService,
        ImpuestoPorcentajeService
    ]
})
export class PuntoVentaTactilAddComponent implements OnInit {
    public categorias: Array<Categoria>;
    public productos: Array<Producto>;
    public loading: boolean;
    public categoria_id: String;
    public venta: Venta;
    public detalles: Array<VentaDetalle>;
    public searchText: String;
    public IVA: number;
	public IVA_PARAM: number;
    public Mod_FactElec: string;
    public tipo_comprobante_id: String;
    public bsModalRef: BsModalRef;
    public bsModalRefAlert: BsModalRef;
    public bsModalRefCliente: BsModalRef;
    public bsModalRefPrint: BsModalRef;
    public cliente: Cliente;
    public correos:Array<any>;
    public cobro: Cobro;
    public forma_pago_id: String;
    public valor_pago: String;
    public formaspago: Array<any>;
    public totalpago: number;
    public cambio: number;
    public vl: Validation;
    public codigo_producto: String;
    public bodega_id: String;
    //@ViewChild('inputSearch') inputSearch;
    //@ViewChild('inputBarcode') inputBarcode;
    public product_barcode: Producto;
    public notfound_barcode: any;
    public radioModel = "FACT";
    public asignacion_id: number;
    public caja: Caja;
    public sucursal_establecimiento: String;
    public msgSweet: SweetMessage;
    public isPrinted: boolean;
    public ventaIdPrinted: String;
    public Mod_Inventario: string;
    public bodegas: Array<Bodega>;
    public tipos_tarjetas: Array<TipoTarjeta>;
    public tipo_tarjeta_id: String;
    public debito_credito: String;
    public config: ConfigService;
    public uploadfile_api: String;
    public tactilLayaut: boolean = false;
    public iva_id: number;
	public iva_porcentaje : any;
	public parametros: Array<any>;
    
    constructor(
        private categoriaService: CategoriaService,
        private productoService: ProductoService,
        private ventaService: VentaService,
        private parametroService: ParametroService,
        public ss: SessionService,
        public tipoComprobanteService: TipoComprobanteService,
        private modalService: BsModalService,
        private clienteService: ClienteService,
        public formaPagoService: FormaPagoService,
        public asignacionService: AsignacionCajaService,
        public cajaService: CajaService,
        public cbtContadorService: CbtContadorService,
        public bodegaService: BodegaService,
        private tipoTarjetaService: TipoTarjetaService,
        public impuestoPorcentajeService: ImpuestoPorcentajeService

    ) {
        this.categorias = [];
        this.productos = [];
        this.loading = false;
        this.categoria_id = "";
        this.venta = new Venta();
        this.detalles = [];
        this.searchText = "";
        this.IVA = 0;
        this.IVA_PARAM = 0;
        this.Mod_FactElec = this.ss.getData("mod_felectronica");
        this.tipo_comprobante_id = "";
        this.bsModalRef = new BsModalRef();
        this.bsModalRefAlert = new BsModalRef();
        this.bsModalRefCliente = new BsModalRef();
        this.cliente = new Cliente();
        this.correos = [];
        this.cobro = new Cobro();
        this.forma_pago_id = "1";
        this.valor_pago = "";
        this.formaspago = [];
        this.totalpago = 0;
        this.cambio = 0;
        this.vl = new Validation();
        this.bodega_id = "1";
        this.codigo_producto = "";
        this.product_barcode = null;
        this.notfound_barcode = null;
        this.asignacion_id = 0;
        this.caja = new Caja();
        this.sucursal_establecimiento = this.ss.getData('sucursal_establecimiento');
        this.msgSweet = new SweetMessage();
        this.isPrinted = false;
        this.ventaIdPrinted = "";
        this.Mod_Inventario = this.ss.getData("mod_inventario");
        this.bodegas = [];
        this.tipos_tarjetas = [];
        this.tipo_tarjeta_id = "";
        this.debito_credito = "D";
        this.config = new ConfigService();
        this.uploadfile_api = environment.uploadfile_api;
        this.tactilLayaut = localStorage.getItem('tactilLayaut') == "true";
        this.iva_id = 0;
		this.parametros = [];
		this.iva_porcentaje = 0;
    }

	ngOnInit() {
        let p1 = this.getCategorias();
        let p2 = this.getParametros();
        let p3 = this.getTiposComprobante();
        let p4 = this.getClienteById();
        let p5 = this.getFormasPago();
        let p6 = this.onAperturaCaja();
        let p7 = this.getBodegas();
        let p8 = this.getTiposTarjeta();
        let p9 = this.getBodegaBySucursal();
        let p10 = this.getIVA(129);
        this.getParametros();
        this.loading = true;
        Promise.all([p1,p3,p4,p5,p6,p7,p8,p9,p10]).then(
            res => this.loading = false,
            err => this.loading = false,
        );

        //this.inputSearch.nativeElement.focus();

            if( this.Mod_FactElec ){
                this.tipo_comprobante_id = "4";
            }else{
                this.tipo_comprobante_id = "1";
            }
    }
    getIVA(id) {
		return new Promise((resolve, reject) => {

			this.impuestoPorcentajeService.getById(id).subscribe(
				res => {
					this.iva_porcentaje = (res.porcentaje*100)/100;
					this.IVA = parseFloat(this.iva_porcentaje) / 100;
                    this.IVA_PARAM = this.iva_porcentaje;
                    this.calcularTotales();
                    resolve();
				},
				err => {
					this.iva_porcentaje = 0;
                    this.IVA = 0;
                    this.IVA_PARAM = 0;
					reject(err);
				}
			);

			
		});
	}

	getParametros() {
		return new Promise((resolve, reject) => {
			let qs ="?impuesto_id=2&is_tarifa=1&is_vigente=1&is_comprobante=1";
			this.impuestoPorcentajeService.getAll(qs).subscribe(
				res => {
					this.parametros = res.data;
					this.iva_id = this.parametros[0].id;
					resolve();
				},
				err => {
					this.parametros = [];
					reject(err);
				}
			);

		});
	}

	onChangeIva(id) {
		this.loading = true;

		this.getIVA(id).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}


    onAperturaCaja(){
        return new Promise((resolve, reject) => {
            let qs = "?usuario_id=" + this.ss.getData('usuario_id');
            this.asignacionService.getAsignacion(qs).subscribe(
                res => {
                    if (res['tipo'] == 'A') {
                        this.asignacion_id = res['id'];
                        this.onCaja(res['caja_id']).then(
                            res => resolve(),
                            err => reject(err),
                        );
                    }else{
                        const initialState = { caja_id: 0 };
                        this.bsModalRef = this.modalService.show(AperturaCajaModalComponent, Object.assign({backdrop: 'static'}, {initialState}));

                        this.bsModalRef.content.action.take(1).subscribe((caja_id) => {
                            //this.onCaja(caja_id);

                            let qs = "?usuario_id=" + this.ss.getData('usuario_id');
                            this.asignacionService.getAsignacion(qs).subscribe(
                                res => {
                                    if (res['tipo'] == 'A') {
                                        this.asignacion_id = res['id'];
                                        this.onCaja(res['caja_id']).then(
                                            res => resolve(),
                                            err => reject(err),
                                        );
                                    }else{
                                        resolve();
                                    }
                                },
                                err => {
                                    reject(err);
                                }
                            );
                        });

                        resolve();
                    }
                },
                err => {

                }
            );
        });
    }

    onCaja($id){
        return new Promise((resolve, reject) => {
            this.cajaService.getById($id).subscribe(
                res => {
                    this.caja = res;
                    resolve();
                },
                err => {
                    reject(err);
                }
            );
        });
    }

    onCierreCaja(){
        const initialState = { asignacion_id: this.asignacion_id , Respuesta:false };
        this.bsModalRef = this.modalService.show(CierreCajaModalComponent, Object.assign({}, {initialState}));

        this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
            if(Respuesta == true){
                this.caja = new Caja();
                this.onAperturaCaja();
            }
        });
    }

    getBodegas(){
        return new Promise((resolve, reject)=>{
            this.bodegaService.getAll("?sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
                res => {
                    if (!res.data.length) {
                        this.bodegas = [];
                    } else {
                        this.bodegas = res.data;
                        //this.bodegas_selected.push(this.bodegas[0].id);
                    }
                    resolve();
                },
                err => {
                    this.bodegas = [];
                    reject(err);
                }
            );
        });		
    }

    getBodegaBySucursal(){
        return new Promise((resolve, reject) => {
            if( !this.Mod_Inventario ){
                //this.venta.bodega_id = "1"; // BODEGA POR DEFECTO / SUCURSAL 1
                this.bodega_id = "1";
                resolve();
            }else{
                this.bodegaService.getAll("?sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
                    res => {
                        this.bodega_id = res.data[0].id;
                        resolve();
                    },
                    err => {
                        this.bodega_id = "";
                        reject()
                    }
                );
            }
        });
    }
    
    getTiposTarjeta(){
        return new Promise((resolve, reject) => {
            this.tipoTarjetaService.getAll().subscribe(
                res => {
                    this.tipos_tarjetas = res.data;
                    resolve();
                },
                err => {
                    this.tipos_tarjetas = [];
                    reject(err);
                }
            );
        });
    }
    
    getCategorias(){
        return new Promise((resolve, reject) => {
            this.categoriaService.getAll().subscribe(
                res => {
                    this.categorias = res.data;
                    this.getProductosByCategoria().then(
                        res => resolve(),
                        err => reject(err)
                    );
                },
                err => {
                    this.categorias = [];
                    reject(err);
                }
            );
        });
    }

    getProductosByCategoria(){
        return new Promise((resolve, reject) => {
            let qs  = "?";
            if( this.categoria_id ) qs = "?categoria_id=" + this.categoria_id;
            
            if( this.searchText.trim().length > 0 ) qs += "&q[producto.nombre]=" + this.searchText.trim() + "&q[producto.descripcion]=" + this.searchText.trim() + "&q[producto.codigo]=" + this.searchText.trim();

            this.productoService.getWithPrice(this.bodega_id,qs).subscribe(
                res => {
                    this.productos = res.data;
                    resolve();
                },
                err => {
                    this.productos = [];
                    reject(err);
                }
            );
        });
    }

    /*onSearchBarcode(event){
        let keycode = event.charCode;

        if( event.keyCode == 13 ){
            this.loading = true;
            this.getProductByCodigo().then(
                res => {
                    this.codigo_producto = "";
                    this.loading = false;
                },
                err => this.loading = false
            );
        }
    }

    getProductByCodigo(){
        return new Promise((resolve, reject) => {
            let qs  = "?codigo=" + this.codigo_producto;

            this.product_barcode = null;
            this.notfound_barcode = null;

            this.productoService.getWithPrice(this.bodega_id,qs).subscribe(
                res => {
                    let producto = res.data[0];

                    if( producto ) {
                        this.product_barcode = producto;
                        this.addProduct(producto);
                    }else{
                        this.notfound_barcode = this.codigo_producto;
                    }
                    
                    resolve();
                },
                err => {
                    this.productos = [];
                    reject(err);
                }
            );
        });
    }*/

    /*getIVA(){
		return new Promise((resolve, reject) => {
			this.parametroService.getById(1).subscribe(
				res => {
                    this.IVA = parseFloat(res.valor) / 100;
                    this.IVA_PARAM = res.valor;
					resolve();
				},
				err => {
                    this.IVA = 0;
                    this.IVA_PARAM = 0;
					reject(err);
				}
			);
		});
    }*/

    getTiposComprobante(){
        return new Promise((resolve, reject)=>{
            let Identif = "";
            if(this.Mod_FactElec){
                Identif = "4";
            }else{
                Identif = "1";
            }

            this.tipoComprobanteService.getAll("?id=" + Identif).subscribe(
                res => {
                    if( res.data.length ){
                        this.tipo_comprobante_id = res.data[0].id;
                    }else{
                        this.tipo_comprobante_id = "";
                    }
                    resolve();
                },
                err => {
                    this.tipo_comprobante_id = "";
                    reject(err);
                }
            );
        });
    }

    getClienteById(){
        return new Promise((resolve, reject) => {
            let cliente_cfinal_id = "1";
            this.clienteService.getById(cliente_cfinal_id, "?embed=tipoidentificacion").subscribe(
                res => {
                    this.cliente = res.data;
                    this.correos = this.cliente.correo.split(',');
                    resolve();
                },
                err => {
                    this.cliente = new Cliente();
                    reject(err);
                }
            );
        });
    }

    getFormasPago(){
        return new Promise((resolve, reject) => {
            this.formaPagoService.getAll().subscribe(
                res  => {
                    this.formaspago = res.data;
                    resolve();
                },
                err => {
                    this.formaspago = [];
                    reject(err);
                }
            );
        });
    }

    onChangeCategoria(){
        if( !this.bodega_id ){
            //this.categoria_id = "";
            this.productos = [];
            this.msgSweet.showMessage('error-message', "Seleccione la bodega");
            return;
        }

        this.loading = true;
        this.getProductosByCategoria().then(
            res => this.loading = false,
            err => this.loading = false,
        );
    }

    onChangeBodega(){
        this.loading = true;
        this.getProductosByCategoria().then(
            res => this.loading = false,
            err => this.loading = false,
        );
    }

    addProduct(producto){
		let venta_detalle = new VentaDetalle();
        venta_detalle.cantidad_stock = producto.cantidad_stock;
        venta_detalle.cantidad = (producto.cantidad?producto.cantidad:1);
        // venta_detalle.es_servicio = producto.es_servicio;
        venta_detalle.tipo_producto_id = producto.tipo_producto_id;
        venta_detalle.descripcion = producto.descripcion;
        venta_detalle.producto = producto.nombre;
        venta_detalle.codigo = producto.codigo;
        venta_detalle.unidad = producto.unidad;
        venta_detalle.producto_id = producto.id;
        venta_detalle.graba_iva = producto.graba_iva;
        venta_detalle.precio_unitario = parseFloat(producto.precio);
        venta_detalle.subtotal = venta_detalle.cantidad * venta_detalle.precio_unitario;
        venta_detalle.usuario_id = this.ss.getData('usuario_id');
        venta_detalle.empresa_id = this.ss.getData('empresa_id');
        venta_detalle.sucursal_id = this.ss.getData('sucursal_id');

        this.detalles.unshift(venta_detalle);

        this.calcularTotales();
    }

    removeProduct(i){
        this.detalles.splice(i, 1);
        this.calcularTotales();
    }

    calcularTotales(){
        // this.detalles.forEach(obj => {
		// 	if( (this.venta.tipo_comprobante_id === '1' && obj.graba_iva) || this.venta.tipo_comprobante_id === '4' && obj.graba_iva ){
        //         this.venta.subtotal_iva12 += obj.subtotal;
        //     }else{
        //         this.venta.subtotal_iva0 += obj.subtotal;
        //     }
        // });
        this.venta = this.ventaService.calcularTotales(this.venta,this.tipo_comprobante_id,this.detalles,this.IVA,0);
    }

    add(detalle){
        detalle.cantidad ++;
        detalle.subtotal = detalle.cantidad * detalle.precio_unitario;
        
        this.calcularTotales();
    }
    
	sub(detalle){
		if( detalle.cantidad > 1 ){
			detalle.cantidad --;
            detalle.subtotal = detalle.cantidad * detalle.precio_unitario;
            
            this.calcularTotales();
		}
    }
    
    onSearchText(){
        this.loading = true;
        this.getProductosByCategoria().then(
            res => this.loading = false,
            err => this.loading = false,
        );
    }

    full(){
        document.documentElement.requestFullscreen();
    }

    onCobrar(template: TemplateRef<any>){
        this.ventaIdPrinted = "";
        this.bsModalRef = this.modalService.show(template,Object.assign({}, { class: 'modal-xlg' }));
    }

   /* onBarCode(template: TemplateRef<any>){
        this.bsModalRef = this.modalService.show(template);
        //this.bsModalRef.content.inputBarcode.nativeElement.focus();
        //this.bsModalRef.content.inputBarcode.nativeElement.focus();
        this.product_barcode = null;
        this.notfound_barcode = null;
    }*/
    onBarCode(){
        //this.bsModalRef = this.modalService.show(template);
        const initialState = {bodega_id: this.venta.bodega_id};
        this.bsModalRef = this.modalService.show(LectorBarraModalComponent, Object.assign({}, {initialState}));
        this.bsModalRef.content.sendProducto.subscribe((value) => {
            let producto:Producto = value;
            //this.addProduct(producto);
            // let productos:Array<Producto> = value;
            // productos.forEach((producto)=>{
            //     this.addProduct(producto);
            // })  
            // this.detalles.forEach(d=>{
            //     if(d.codigo == producto.codigo){
            //     }else{
            //         this.addProduct(producto);
            //     }
            // });
            let d = this.detalles.filter(d => d.codigo === producto.codigo);
            // if (d.length > 0) {
            //     /* vendors contains the element we're looking for */
            //     d[0].cantidad += 1;
            //     d[0].subtotal = d[0].cantidad * d[0].precio_unitario;
            // }else{
                this.addProduct(producto);
           // }
		});
        //this.bsModalRef.content.inputBarcode.nativeElement.focus();
        //this.bsModalRef.content.inputBarcode.nativeElement.focus();
        this.product_barcode = null;
        this.notfound_barcode = null;
    }



    onSearchCliente(event) {
        if( event.keyCode === 13 ){
			if( this.cliente.dni.toString().trim().length == 0 ){
				this.cliente = new Cliente();
				return;
			}else{
				this.clienteService.getByDni(this.cliente.dni).subscribe(
					res => {
						this.loading = false;
						if (res.length > 0) {
							this.cliente = res[0];
						}else{
							this.cliente = new Cliente();
							this.openDialogCliente();
						}
					},
					err => {
						this.loading = false;
						this.openDialogCliente();
					}
				);
			}
        }
    }
    
    openDialogCliente() {
		const initialState = {qs: "&embed=tipoidentificacion"};
		this.bsModalRefCliente = this.modalService.show(ClienteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRefCliente.content.sendCliente.take(1).subscribe((cliente) => {
            this.cliente = cliente;
            this.correos = this.cliente.correo.split(',');
        });
    }

    addCobro(){
        if( this.valor_pago.toString().trim().length < 1 || parseFloat(this.valor_pago.toString()) < 0.01){
            this.msgSweet.showMessage('error-message', "Ingrese el valor del pago");
            return;
        }

        let cobro_detalle = new CobroDetalle();
        cobro_detalle.valor = parseFloat(this.valor_pago.toString());
        cobro_detalle.forma_pago_id = this.forma_pago_id;
        cobro_detalle.empresa_id = this.ss.getData("empresa_id");
        cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
        cobro_detalle.usuario_id = this.ss.getData("usuario_id");

        this.cobro.detalle.push(cobro_detalle);
        this.valor_pago = "";

        this.calcularTotalPago();
    }

    removePago(i){
        this.cobro.detalle.splice(i, 1);
        this.calcularTotalPago();
    }

    calcularTotalPago(){
        this.totalpago = 0;
        this.cobro.detalle.forEach(detalle => {
            this.totalpago = parseFloat(this.totalpago.toString()) + parseFloat(detalle.valor.toString());
        });
        this.cambio = (this.totalpago > this.venta.total?(this.totalpago - this.venta.total):0);
        this.cambio = Math.round(this.cambio * 100) / 100;
    }

    verFormaPago(forma_pago_id){
        return this.formaspago.filter(x => x.id == forma_pago_id)[0].nombre;
    }

    onClearSearch(){
        this.searchText = "";
        //this.inputSearch.nativeElement.focus();
        this.loading = true;
        this.getProductosByCategoria().then(
            res => this.loading = false,
            err => this.loading = false,
        );
    }

    onChangeTipoDoc(){
        if( this.radioModel == "FACT"){
            if( this.Mod_FactElec ){
                this.tipo_comprobante_id = "4";
            }else{
                this.tipo_comprobante_id = "1";
            }
        }else{
            this.tipo_comprobante_id = "2";
        }

        this.ventaIdPrinted = "";
        this.calcularTotales();
    }

    setValueEntity(){
        this.venta.caja_id = this.caja.id;
        this.venta.asignacion_caja_id = this.asignacion_id.toString();
        //this.venta.is_secuencial_manual = this.is_numero_manual;
        //if( this.is_numero_manual ) this.venta.numero_documento = this.numero_documento;
        this.venta.tipo_comprobante_id = this.tipo_comprobante_id;

        this.venta.serie = this.sucursal_establecimiento;
        this.venta.punto_emision = this.caja.punto_emision;
        //this.venta.secuencial = res.secuencial;

        this.venta.numero_documento = this.venta.serie + "-" + this.venta.punto_emision + "-" + this.venta.secuencial;

        this.venta.cliente_id = this.cliente.id;
        this.venta.cliente = this.cliente;
        this.venta.fecha_emision = moment().format("YYYY-MM-DD")
        this.venta.usuario_id = this.ss.getData('usuario_id');
        this.venta.empresa_id = this.ss.getData('empresa_id');
        this.venta.sucursal_id = this.ss.getData('sucursal_id');
        this.venta.cobros = [];

        let recibido = 0;

        this.cobro.detalle.forEach(detalle => {
            recibido = recibido + parseFloat(detalle.valor.toString());
        });

        this.cobro.recibido = recibido;
        this.cobro.cambio = this.cambio; //(recibido > this.venta.total ? recibido - this.venta.total : 0 );
        this.cobro.saldo = this.venta.total;
        this.cobro.fecha_cobro = moment().format("YYYY-MM-DD");

        this.venta.cobros.push(this.cobro);

        this.detalles.forEach(detalle => {
            if( parseInt(this.venta.tipo_comprobante_id.toString()) === 1 || parseInt(this.venta.tipo_comprobante_id.toString()) === 4 ){
                if( !detalle.graba_iva ){
                    detalle.iva = 0;
                }else{
                    detalle.iva = detalle.subtotal * this.IVA;
                }
            }else{
                detalle.iva = 0;
            }
            detalle.total = detalle.subtotal + detalle.iva;
        });

        this.venta.detalle = this.detalles;

    }
    
    setVentaElectronica(venta: Venta){
        let ventaElectronica = {};
        ventaElectronica['datos'] = {};
        ventaElectronica['datos']['infoTributaria'] = {};
        ventaElectronica['datos']['infoTributaria']['ambiente'] = "";
        ventaElectronica['datos']['infoTributaria']['tipoEmision'] = 1;
        ventaElectronica['datos']['infoTributaria']['razonSocial'] = "";
        ventaElectronica['datos']['infoTributaria']['ruc'] = this.ss.getData('emp_ruc');
        ventaElectronica['datos']['infoTributaria']['claveAcceso'] = "";
        ventaElectronica['datos']['infoTributaria']['codDoc'] = "01"; //Factura
        ventaElectronica['datos']['infoTributaria']['estab'] = venta.serie;
        ventaElectronica['datos']['infoTributaria']['ptoEmi'] = venta.punto_emision;
        ventaElectronica['datos']['infoTributaria']['secuencial'] = venta.secuencial.toString().padStart(9,"0");
        ventaElectronica['datos']['infoTributaria']['dirMatriz'] = ""; //this.ss.getData('emp_direccion');

        ventaElectronica['datos']['infoFactura'] = {};
        ventaElectronica['datos']['infoFactura']['fechaEmision'] =  moment(venta.fecha_emision).format("DD/MM/YYYY");
        ventaElectronica['datos']['infoFactura']['dirEstablecimiento'] = this.ss.getData('sucursal_direccion');
        ventaElectronica['datos']['infoFactura']['tipoIdentificacionComprador'] = this.cliente.tipoidentificacion.cod_dni;
        ventaElectronica['datos']['infoFactura']['razonSocialComprador'] = this.cliente.razon_social.toString().replace("&","Y");
        ventaElectronica['datos']['infoFactura']['identificacionComprador'] = this.cliente.dni;

        let totalSinImpuestos = 0;
        this.venta.detalle.forEach(item => {
            totalSinImpuestos += Math.round(item.subtotal * 100) / 100;
        });

        ventaElectronica['datos']['infoFactura']['totalSinImpuestos'] = totalSinImpuestos;
        ventaElectronica['datos']['infoFactura']['totalDescuento'] = venta.desct_valor;

        ventaElectronica['datos']['infoFactura']['totalConImpuestos'] = [];
        if(venta.subtotal_iva0 > 0){
            let totalConImpuestos = {};
            totalConImpuestos['codigo'] = 2;
            totalConImpuestos['codigoPorcentaje'] = 0;
            totalConImpuestos['descuentoAdicional'] = (Math.round(venta.desct_valor * 100) / 100);
            totalConImpuestos['baseImponible'] = (Math.round(venta.subtotal_iva0 * 100) / 100);
            totalConImpuestos['valor'] = "0.00";

            ventaElectronica['datos']['infoFactura']['totalConImpuestos'].push(totalConImpuestos);
        }

        if(venta.subtotal_iva12 > 0){
            let totalConImpuestos = {};
            totalConImpuestos['codigo'] = 2;
            totalConImpuestos['codigoPorcentaje'] = 2;
            totalConImpuestos['descuentoAdicional'] = (Math.round(venta.desct_valor * 100) / 100);
            totalConImpuestos['baseImponible'] = (Math.round(venta.subtotal_iva12 * 100) / 100);
            totalConImpuestos['valor'] = (Math.round(venta.iva * 100) / 100);

            ventaElectronica['datos']['infoFactura']['totalConImpuestos'].push(totalConImpuestos);
        }

        ventaElectronica['datos']['infoFactura']['propina'] = "0.00";
        ventaElectronica['datos']['infoFactura']['importeTotal'] = (Math.round(venta.total * 100) / 100);
        ventaElectronica['datos']['infoFactura']['moneda'] = "DOLAR";

        ventaElectronica['datos']['infoFactura']['pagos'] = [];

        //if( this.venta.tipo == "CO" ){
            //01 => EFECTIVO
            let totalEfectivo = 0;
            this.cobro.detalle.forEach(detalle => {
                if( detalle.forma_pago_id == "1" ){ // EFECTIVO
                    totalEfectivo += parseFloat(detalle.valor.toString());
                }
            });

            if( totalEfectivo > 0 ){
                let pago = {};
                pago["formaPago"] = "01";
                pago["total"] = (Math.round((parseFloat(totalEfectivo.toString()) - parseFloat(this.cambio.toString())) * 100) / 100);
                pago["plazo"] = "0";
                pago["unidadTiempo"] = "DIAS";
                ventaElectronica['datos']['infoFactura']['pagos'].push(pago);
            }

            /*this.valorefectivo = Math.round(this.valorefectivo * 100) / 100;
            if( this.valorefectivo > 0 ){
                let pago = {};
                pago["formaPago"] = "01";
                pago["total"] = (Math.round((parseFloat(this.valorefectivo.toString()) - parseFloat(this.cambio.toString())) * 100) / 100);
                pago["plazo"] = "0";
                pago["unidadTiempo"] = "DIAS";
                ventaElectronica['datos']['infoFactura']['pagos'].push(pago);
            }*/

            /*let totalChOtrosCon = 0;
            this.cheques.forEach(ch => {
                totalChOtrosCon += parseFloat(ch.valor.toString());
            });*/

            //20 => OTROS
            /*totalChOtrosCon = Math.round(totalChOtrosCon * 100) / 100;;
            if( totalChOtrosCon > 0 ){
                let pago = {};
                pago["formaPago"] = "20";
                pago["total"] = (Math.round(totalChOtrosCon * 100) / 100);
                pago["plazo"] = "0";
                pago["unidadTiempo"] = "DIAS";
                ventaElectronica['datos']['infoFactura']['pagos'].push(pago);
            }*/

            //16 => DEBITO; 19 => CREDITO
            /*this.tarjetas.forEach(tr => {
                let pago = {};
                pago["formaPago"] = (tr.debito_credito==="D"?"16":"19");
                tr.valor = Math.round(tr.valor * 100) / 100;;
                pago["total"] = (Math.round(tr.valor * 100) / 100);
                pago["plazo"] = tr.plazo;
                pago["unidadTiempo"] = tr.tiempo.toUpperCase();
                ventaElectronica['datos']['infoFactura']['pagos'].push(pago);
            });*/
        /*}else{
            //20 => OTROS
            let pago = {};
            pago["formaPago"] = "20";
            let valor = parseFloat(venta.total.toString()) - parseFloat(this.cambio.toString())
            //valor = Math.round(valor * 100) / 100;
            pago["total"] = (Math.round(valor * 100) / 100);
            pago["plazo"] = "0";
            pago["unidadTiempo"] = "DIAS";
            ventaElectronica['datos']['infoFactura']['pagos'].push(pago);
        }*/

        ventaElectronica['datos']['detalles'] = [];
        venta.detalle.forEach((item) => {
            let detalle = {};
            let detalle_item = item.detalle.toString().replace(/\n/g,", ");

            detalle['codigoPrincipal'] = (item.codigo).replace(/\//g,'-');
            detalle['codigoAuxiliar'] = (item.codigo).replace(/\//g,'-');
            detalle['descripcion']  = (item.producto + (item.detalle.length>0?" - " + detalle_item:"")).replace(/\//g,'-');
            detalle['cantidad'] = item.cantidad;
            detalle['precioUnitario'] = (Math.round(item.precio_unitario * 100) / 100);
            detalle['descuento'] = (Math.round(item.desc_valor * 100) / 100);
            detalle['precioTotalSinImpuesto'] = (Math.round(item.subtotal * 100) / 100);
            detalle['impuestos'] = [];
            let impuesto = {};
            impuesto['codigo'] = 2;
            impuesto['codigoPorcentaje'] = (item.iva > 0 ? 2 : 0 );
            impuesto['tarifa'] = (item.iva  > 0 ? 12 : 0 );
            impuesto['baseImponible'] = (Math.round(item.subtotal * 100) / 100);
            impuesto['valor'] = Math.round(item.iva * 100) / 100;
            detalle['impuestos'].push(impuesto);
            ventaElectronica['datos']['detalles'].push(detalle);
        });
        
        ventaElectronica['datos']['infoAdicional'] = [];
        let adicional = {};
        adicional['Email'] = this.correos.toString(); //this.cliente.correo;
        adicional['Direccion'] = this.cliente.direccion.replace(/\//g,'-');

        let telefono = "0999999999";
        if( this.cliente.telefono.toString().trim().length > 0 ){
            telefono = this.cliente.telefono.toString();
        }
        if( this.cliente.celular.toString().trim().length > 0 ){
            telefono = this.cliente.celular.toString();
        }
        adicional['Telefono'] = telefono;

        /*this.datos.forEach(dato => {
            adicional[dato.descripcion.toString()] = dato.valor.toString();
        });*/

        ventaElectronica['datos']['infoAdicional'].push(adicional);

        return ventaElectronica;
    }

    onSubmit() {
        let preg = "¿Está seguro de confirmar la venta?";
        const initialState = { Pregunta: preg, Respuesta:false };
        this.bsModalRefAlert = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));
        
        this.bsModalRefAlert.content.action.take(1).subscribe((Respuesta) => {
            if(Respuesta == true){
                //this.setValueCobro();
                this.setValueEntity();

                if( this.Mod_FactElec ){
                    if( this.venta.cliente.es_contribuyente ){
                        if( this.venta.cliente.num_contribuyente.toString().trim().length === 0 ){
                            this.msgSweet.showMessage('error-message', "El cliente no consta con número de contribuyente");
                            return false;
                        }
                    }
                    if(this.venta.total >= 200 && this.venta.cliente.id == "1" && this.tipo_comprobante_id == "4"){
                        this.msgSweet.showMessage('error-message', "No puede realizar una venta cuyo monto supere los $200 a Consumidor Final");
                        return false;
                    }
                    this.venta.json_string = this.setVentaElectronica(this.venta);
                }

                this.cliente.correo = this.correos.toString();

                this.loading = true;
                this.ventaService.save(this.venta).subscribe(
                    res => {
                        this.loading = false;
                        
                        if( this.Mod_FactElec ){
                            this.cbtContadorService.actualizarContador();
                        }

                        this.isPrinted = true;
                        this.ventaIdPrinted = res.id;

                        this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
                        this.venta = new Venta();
                        this.cliente = new Cliente();
                        this.detalles = [];
                        this.totalpago = 0;
                        this.cambio = 0;
                        this.cobro = new Cobro();
                        this.debito_credito = "D";
                        this.forma_pago_id = "1";

                        this.getClienteById().then();
                    },
                    err => {
                        this.loading = false;
                        this.msgSweet.showMessage('error-message',err);
                    }
                );
            }
        });
    }

    onPrint(){
        if( this.Mod_FactElec ){
            if( this.tipo_comprobante_id == "4" ){ // FACTURA ELECTRONICA
                this.printCbtFactElect();
            }else{ // NOTA DE VENTA
                this.printCbtNotaVenta();
            }
        }else{
            if( this.tipo_comprobante_id == "1"){ //FACTURA FISICA
                this.printFacturaFisica();
            }else{ //NOTA DE VENTA
                this.printCbtNotaVenta();
            }
        }
    }

    printCbtFactElect(){
        const initialState = {route: "cbt/factelect/" + this.ventaIdPrinted, qs: "?dbname=" + this.ss.getData('dbname') + "&factid=" + this.ss.getData('fact_id') + "&facttk=" + this.ss.getData('fact-api-token')};
		this.bsModalRefPrint = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: '', initialState}));
    }

    printCbtNotaVenta(){
        const initialState = {route: "cbt/notaventa/" + this.ventaIdPrinted, qs: "?dbname=" + this.ss.getData('dbname') + "&factid=" + this.ss.getData('fact_id') + "&facttk=" + this.ss.getData('fact-api-token')};
		this.bsModalRefPrint = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: '', initialState}));
    }

    printFacturaFisica(){
        this.printCbtFactElect();
    }

    clickKeyboard(key){
        if( key == "C" ){
            this.valor_pago = this.valor_pago.toString().slice(0,-1)
        }else{
            this.valor_pago = this.valor_pago + key;
        }
    }

    isValidCobrar(){
        if( this.venta.total <= 0){
            return false;
        }
        if( !this.caja.id ){
            return false;
        }
        
        return true;
    }

    isValidGuardar(){
        if( this.totalpago < 0.01 || this.totalpago < this.venta.total ){
            return false;
        }
        if( !this.cliente.id ){
            return false;
        }
        if( this.correos.length <= 0 ){
            return false;
        }
        return true;
    }

    onClosePagoModal(){
        this.bsModalRef.hide();
    }

    setSrcImage(producto){
		return this.uploadfile_api + "/image/" + (producto.imagen!=""?producto.imagen:"nofoto.png") + "/150?tk=" + this.ss.getData('api-token') + "&dbname=" + this.ss.getData('dbname');
    }
    
    setPaddingLayaut(){
        return this.tactilLayaut ? 0 : 20;
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/punto-venta-tactil-add/punto-venta-tactil-add.component.ts